// extracted by mini-css-extract-plugin
export default {"statRow":"StatRow_statRow__OlhtB","statValue":"StatRow_statValue__9RJGw"};